module.exports = __webpack_public_path__ + "media/a6.48a8f5bc.mp3";